// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';
import Image from 'components/common/Image';

import styles from './PromotionTile.module.scss';

const PromotionTile = ({
  src,
  className,
  focusId,
  ttsText,
  onClick,
  onFocusSet,
}) => (
  <Selectable
    onSelect={onClick}
    focusId={focusId}
    className={className}
    ttsText={ttsText}
    onFocusSet={onFocusSet}
    data-testid="promotion-tile"
    render={({ hasFocus }) => (
      <div
        className={classNames(
          'd-flex',
          'flex-column',
          styles.tile,
          hasFocus ? styles.focused : styles.unfocused,
        )}
      >
        <button
          type="button"
          onClick={onClick}
          // Safari hides the outline if the style is applied to the internal div
          className={classNames(
            'w-100 h-100',
            'position-relative',
            styles.button,
          )}
        >
          <Image
            alt="promotion tile background"
            src={src}
            className={classNames('w-100', 'h-100', styles.image)}
            data-testid="background-image"
          />
          <div className={classNames('w-100', 'h-100', styles.imageOverlay)} />
        </button>
      </div>
    )}
  />
);

PromotionTile.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  ttsText: PropTypes.string.isRequired,
  focusId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onFocusSet: PropTypes.func,
};

PromotionTile.defaultProps = {
  className: null,
  onClick: () => {},
  onFocusSet: () => {},
};

export default React.memo(PromotionTile);
